import React from "react";
import { ChevronRight } from "lucide-react";

import { useAppSelector } from "../../../app/hooks";
import { selectChargeById } from "../Logic/chargesSlice";
import { selectAssetEntities } from "../Logic/assetsSlice";

import {
  SECURITY_ROLE_LABELS,
  CHARGE_MODE_LABELS,
  DISTRIBUTION_RIGHTS_LABELS,
  PUBLIC_CHARGE_REGISTRY_LABELS,
} from "../../../api/charges";
import { ASSET_TYPE_LABELS, AssetType } from "../../../api/assets";

interface ChargeCardProps {
  chargeId: string;
  onManage: (chargeId: string) => void;
}

const ChargeCard: React.FC<ChargeCardProps> = ({
  chargeId,
  onManage,
}) => {
  const chargeResponse = useAppSelector((state) =>selectChargeById(state, chargeId));

  const assetEntities = useAppSelector(selectAssetEntities);

  if (!chargeResponse) {
    return null;
  }

  const { charges, asset_linkages } = chargeResponse;

  const assetTypes: AssetType[] = [];
  asset_linkages.forEach((linkage) => {
    const assetType = assetEntities[linkage.asset_id]?.asset_type;
    if (assetType && !assetTypes.includes(assetType)) {
      assetTypes.push(assetType);
    }
  });

  const assetTypesString = assetTypes.map((type) => ASSET_TYPE_LABELS[type]).join(", ");

  const securityInterestId = charges.registry_identifiers?.security_interest_id ?? "";

  const name = `${SECURITY_ROLE_LABELS[charges.security_role!]}  (${securityInterestId})`;
  const description = `${CHARGE_MODE_LABELS[charges.charge_mode!]} • ${DISTRIBUTION_RIGHTS_LABELS[charges.distribution_rights!]} • ${PUBLIC_CHARGE_REGISTRY_LABELS[charges.public_registry]}`;

  return (
    <div
      className="
        flex
        items-center
        justify-between
        gap-4
        rounded-[2px]
        bg-[#F9FAFB]
        p-2
      "
    >
      <div className="flex min-w-0 flex-1 flex-col gap-1">
        <div className="flex min-w-0 items-center gap-2">
          <span
            className="
              text-[14px]
              font-normal
              leading-5
              text-[#0A0A0A]
            "
          >
            {name}
          </span>

          {!!assetTypesString && (
            <span
              className="
                inline-block
                min-w-5
                max-w-[40vw]
                truncate
                items-center
                rounded-[8px]
                border
                border-transparent
                bg-[#E5E7EB]
                px-2
                py-[2px]
                text-[12px]
                font-medium
                leading-4
                text-[#4B5563]
              "        
              title={assetTypesString} 
            >
              {assetTypesString}
            </span>
          )}
        </div>

        <span
          className="
            text-[12px]
            font-normal
            leading-4
            text-[#737373]
          "
        >
          {description}
        </span>
      </div>

      <button
        type="button"
        onClick={() => onManage(chargeId)}
        className="
          flex
          shrink-0
          items-center
          justify-center
          gap-[2px]
          rounded-md
          p-0
          text-[12px]
          font-medium
          leading-4
          text-[#3551F3]
        "
      >
        <span>Manage</span>

        <ChevronRight
          size={16}
          className="text-[#3551F3]"
        />
      </button>
    </div>
  );
};

export default ChargeCard;